import { DEFAULT_NAME_PREFIX } from "./constants.js";
import { hashString } from "./hashString.js";
import { serializeCSSObject } from "./serializeCSSObject.js";
// TODO: Consider renaming to `AnimationKeyframes` and create a separate `Animation` class
// that handles the animation options and rendering.
// Should be able to maintain backwards compatibility with the current usage.
export class Animation {
    /**
     * Creates a new animation from the provided keyframes.
     */
    static keyframes(keyframes, options) {
        return new Animation(keyframes, options);
    }
    #keyframes;
    #rendered;
    #getRendered() {
        if (this.#rendered === undefined) {
            this.#rendered = this.#render();
        }
        return this.#rendered;
    }
    get name() {
        return this.#getRendered().name;
    }
    toCSSString() {
        return this.#getRendered().cssString;
    }
    /**
     * The document to use for rendering.
     */
    #document;
    /**
     * Prefix for serialized names.
     */
    // TODO: Expose this as an option.
    #namePrefix = DEFAULT_NAME_PREFIX;
    constructor(keyframes, options = {}) {
        this.#document = options.document ?? globalThis.document;
        this.#keyframes = keyframes;
    }
    #render() {
        const steps = Object.entries(this.#keyframes).map(([progress, value]) => {
            return [progress, serializeCSSObject(this.#document, value)];
        });
        const animationHash = hashString(steps.reduce((result, [progress, { hash }]) => {
            return `${result}-${progress}-${hash}`;
        }, ""));
        const name = `${this.#namePrefix}-${animationHash}`;
        const cssString = `@keyframes ${name} {
      ${steps
            .map(([progress, { declarationBlock }]) => {
            return `${progress} { ${declarationBlock} }`;
        })
            .join("\n")}
    }`;
        return {
            name,
            cssString,
        };
    }
}
